<template>
    <b-container fluid class="headerPushDown">
        <b-container v-if="!onSuccess" class=" ml-auto mr-auto">
            <!-- LOGIN FORM -->
            <form @submit.stop.prevent="handleSubmit">
                <h3 class="text-center text-uppercase">Passwort vergessen</h3>
                <b-form-group class="w-100">
                    <b-row >
                        <b-col sm="0" md="3">
                        </b-col>
                        <b-col sm="12" md="6" >
                            <label class="text-uppercase mb-2 mt-2">E-Mail Adresse</label>
                            <b-input type="text" size="md" placeholder="E-Mail" :state="emailState" aria-describedby="input-live-feedback" class="mt-0 mb-2 InputBorder" v-model="login"/>
                            <b-form-invalid-feedback id="input-live-feedback" class="mb-2">
                                Bitte eine E-Mail Adresse angeben
                            </b-form-invalid-feedback>

                            <vue-recaptcha v-if="siteKey" :sitekey="siteKey" ref="recaptcha" @expired="onCaptchaExpired" @verify="onCaptchaVerified"></vue-recaptcha>

                            <b-button v-if="!reCaptchaOK" disabled class="mt-4 text-uppercase" size="md" variant="light" style="float: right;">
                                ABSCHICKEN
                            </b-button>
                            <b-button v-if="reCaptchaOK" @click="handleRegisterSubmit" class="mt-4 text-uppercase" size="md" variant="light" style="float: right;">
                                ABSCHICKEN
                            </b-button>
                            <div v-if="validationError!=''" class="d-inline-block text-danger mb-2">
                                {{validationError}}
                            </div>
                        </b-col>
                        <b-col sm="0" md="3">

                        </b-col>
                    </b-row>
                </b-form-group>
            </form>
        </b-container>
        <b-container v-if="onSuccess">
            <b-row>
                <b-col sm="0" md="2" lg="3"></b-col>
                <b-col sm="12" md="8" lg="6">
                    <h3 class="text-center">Passwort vergessen</h3>
                    <br/>
                    <p class="">Sollten wir einen Account mit Ihrer E-Mail finden, erhalten Sie in Kürze eine E-Mail mit einem Link, mit welchem Sie Ihr Passwort zurücksetzten können.</p>

                </b-col>
                <b-col sm="0" md="2" lg="3"></b-col>
            </b-row>
        </b-container>
  </b-container>
</template>


<script>
import VueRecaptcha from 'vue-recaptcha';

export default {
    name:'ShopRecoverPasswordView',
    components: {
        VueRecaptcha
    },
    data() {
        return {
            login: '',
            siteKey: undefined,
            reCaptchaOK: false,
            reCaptchaToken: undefined,
            onSuccess: false,
            validationError: undefined,
        }
    },
    computed: {
        getSelectedLanguage() {
            return this.$store.getters.getLanguage;
        },
        getLanguageItem: function() {
            return this.$store.getters.getLanguageStrings;
        },
        emailState(){

            if (this.login.length == 0) {
                return undefined;
            }else if(this.login.match(this.$store.getters.getMailFormat) ){
                return true;
            }else{
                return false;
            }
        },
    },
    methods:{
         onCaptchaVerified(recaptchaToken){
           // console.log('recaptchaToken: ', recaptchaToken);
            this.reCaptchaOK = true;
            this.reCaptchaToken = recaptchaToken;
        },
        onCaptchaExpired() {
            this.$refs.recaptcha.reset();
            this.reCaptchaOK = false;
            this.reCaptchaToken = undefined;
        },
        async loadRecaptchaKeyFromServer() {
            let config = this.$store.getters.getRestHeaderConfig;
            config.params = null;

            await this.$http
                .get(this.$store.getters.getRestServerBaseUrl + "/recaptchaKey", config)
                .then(response => {
                    // console.log("GET recaptchaKey: " + response.status);
                    // console.log(response.data);
                    this.siteKey = response.data;

                    //console.log('stored recaptchaKey: ', this.$store.getters.getBasket);
                })
                .catch(err => {
                console.log("GET recaptchaKey ERROR: ", err);

                });
        },
        handleRegisterSubmit(){
            //console.log('state: ',this.emailState);


            if (this.login == undefined || this.login.trim() == '' || this.emailState != true  ) {
                // check in more detail for @ , ?
                this.validationError = 'E-Mail Adresse überprüfen';
                return;
            }

            let params = {
                reCaptcha: this.reCaptchaToken,
                emailAddress: this.login
            };

            // send to Server
            this.postRecoverPasswordToServer(params);
        },
        async postRecoverPasswordToServer(params) {

        let config = this.$store.getters.getRestHeaderConfig;
        config.params = undefined; // make sure they are empty

       // console.log('POST RECOVER:', params, config);

        await this.$http
            .post(this.$store.getters.getRestServerBaseUrl + "/requestPasswordReset", params , config)
            .then(response => {
               // console.log("POST RECOVER response: "  + response.status, response);

                this.onSuccess = true;
response.data ='';

            })
            .catch(err => {
                console.log("POST RECOVER ERROR: ", err.response);
                // TODO: visual ?

                this.onSuccess = true; // to be save
            });
        },
    },
    beforeMount(){
        this.loadRecaptchaKeyFromServer();
    },
    mounted(){
        window.scroll({
            top: 0,
            left: 0,
            behavior: 'smooth'
        });
    }
}
</script>
